import { useCurrentModule } from '../components';
import { PERSONALIZED_CONTENT_QUERY_OPTIONS, usePersonalizedParams } from './usePersonalizedParams';
import { useReportQueryError } from './useReportQueryError';

/**
 * The one `/get-personalized-content` request behind the title, descriptions
 * and features hooks. All three call this with the same params, so react-query
 * dedupes them into one request per page.
 */
export const usePersonalizedContent = () => {
  const module = useCurrentModule();
  const {
    params,
    enabled,
    isLoading: isParamsLoading
  } = usePersonalizedParams();
  const reportQueryError = useReportQueryError();
  const {
    data,
    isSuccess,
    isError,
    isLoading
  } = module.SDK.personalizedContentApiClient.hooks.useGetPersonalizedContent(params, enabled, {
    ...PERSONALIZED_CONTENT_QUERY_OPTIONS,
    onError: error => reportQueryError('getPersonalizedContent', error)
  });
  return {
    data,
    enabled,
    isParamsLoading,
    isSuccess,
    isError,
    isLoading
  };
};
//# sourceMappingURL=usePersonalizedContent.js.map